import { productCardType } from '@/commonTypes';
import PageSubMenu from '@/components/common/PageSubMenu';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import styles from '../styles.module.css';
import HtmlText from '@/components/general/Htmltext';
// import ProductReviews from '../ProductReviews';
import ProductAttributes from './ProductAttributes';
import AttributeBox from './AttributeBox';
import Comments from '@/components/pages/blog/SingleBlogContent/Comments';
import MenuToggle from '../../ProductsContent/TopMenuSection/MenuToggle';
import Divider from '@/components/common/Divider';
import { getGroupedAttributes } from '@/functions/getGroupedAttributes';

export default function ProductMenuSection({ data }: { data?: productCardType }) {
  const [activeMenu, setActiveMenu] = useState(1);
  const tCommon = useTranslations('common');
  const onclickMenu = (x: number | undefined) => {
    x && setActiveMenu(x);
  };
  const menuList = [
    { id: 1, title: tCommon('specifications'), onClick: () => onclickMenu(1) },
    { id: 2, title: tCommon('description'), onClick: () => onclickMenu(2) },
    { id: 3, title: tCommon('reviews'), onClick: () => onclickMenu(3) },
  ];
  const groupedAttributes = getGroupedAttributes(data);

  return (
    <div>
      {/* <PageSubMenu active={activeMenu} menu={menuList} /> */}
      <MenuToggle data={menuList} activeId={activeMenu} className={`${styles.menu}`} />
      {activeMenu == 2 && (
        <div className={`card`}>
          <HtmlText className={`${styles.description}`} content={data?.description} />
          <div className={`${styles.keyspecs}`}>
            {/* {groupedAttributes?.map((item) => (
              <AttributeBox
                key={item?.attributeId}
                title={item?.attributeName}
                value={item?.values.join(', ')}
              />
            ))} */}
          </div>
        </div>
      )}
      {activeMenu == 1 && (
        <div className={`card`}>
          <ProductAttributes
            data={groupedAttributes?.map((x: { attributeName?: string; values: string[] }) => {
              return { ...x, title: x?.attributeName, value: x?.values.join(', ') };
            })}
          />
        </div>
      )}
      {activeMenu == 3 && <Comments targetId={data?.id} showAllRates={true} showRateTitle={true} />}
    </div>
  );
}
